import { AiGoodsList as AiGoodsListComponent } from 'components/goods/ai/AiGoodsList/AiGoodsList'

export const AiGoodsList: React.FC = () => {
  return <AiGoodsListComponent />
}
